import React from 'react';
import { Trans } from 'react-i18next';

const IntegrationsSetupTab = React.lazy(() => import('./IntegrationsSetupTab'));
const ApiKeysSetupTab = React.lazy(() => import('./ApiKeysSetupTab'));
const WebhooksSetupTab = React.lazy(() => import('./WebhooksSetupTab'));
const SftpSetupTab = React.lazy(() => import('./SftpsSetupTab'));

export default [
  {
    id: 'integrations-setup',
    label: <Trans i18nKey='admin-page.integrations-page.tabs.integrations-setup.title' />,
    component: IntegrationsSetupTab,
  },
  {
    id: 'api-keys-setup',
    label: <Trans i18nKey='admin-page.integrations-page.tabs.api-keys-setup.title' />,
    component: ApiKeysSetupTab,
  },
  {
    id: 'webhooks-setup',
    label: <Trans i18nKey='admin-page.integrations-page.tabs.webhooks-setup.title' />,
    component: WebhooksSetupTab,
  },
  {
    id: 'sftps-setup',
    label: <Trans i18nKey='admin-page.integrations-page.tabs.sftps-setup.title' />,
    component: SftpSetupTab,
  },
];
